import type { Translations } from './en.js';

const zhHant: Translations = {
  ok: '確認',
  cancel: '取消',
  close: '關閉',
  confirm: '確認',
  language: '語言',

  game_title: '劍之強化',
  tap_to_start: '點擊開始',
  title_load_failed: '標題圖片載入失敗：',
  game_started: '劍之強化遊戲開始！',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 全部通關！',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (免費！)',

  btn_enhance: '⚒️ 強化',
  btn_enhance_ready: '⚔️ 強化',
  btn_enhance_complete: '🏆 完成',
  btn_free_enhance: '▶ 免費強化',
  btn_exhausted: '已用盡',
  btn_boost: '提升\n機率',
  btn_applying: '套用\n中！',
  btn_protection_active: '🛡️ 保護已啟用',
  btn_protection_use: '🛡️ 使用防護券',
  btn_sell: '💰 出售',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 商店',
  cost_max: 'MAX',
  cost_free: '0 G (免費！)',

  tab_settings: '⚙️ 設定',
  tab_inventory: '📦 背包',
  bgm_on: '🎵 背景音樂 ON',
  bgm_off: '🎵 背景音樂 OFF',
  sfx_on: '🔊 音效 ON',
  sfx_off: '🔊 音效 OFF',
  inventory_title: '⚔️ 保存的武器',
  inventory_empty: '沒有保存的武器',
  equip: '裝備',
  equip_msg: '{name} 已裝備！',
  reset_confirm_title: '⚠️ 確定要重置嗎？',
  reset_confirm_desc: '所有進度將被刪除',
  reset: '重置',
  reset_start_over: '🔄 重新開始',
  menu_close: '關閉',

  inv_scrolls_title: '🛡️ 持有防護券',
  inv_scrolls_line1: '初級：{c0}  |  中級：{c1}',
  inv_scrolls_line2: '高級：{c2}  |  頂級：{c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: '看廣告獲得免費強化',
  ad_gold_desc: '下次強化費用為0',
  ad_gold_note: '（防護券、機率提升仍生效）',
  ad_gold_confirm: '▶ 觀看廣告',
  ad_gold_free_next: '下次強化免費！',
  ad_gold_exhausted: '使用次數已用盡！',
  ad_gold_remaining: '剩餘次數：{current}/3',

  boost_popup_title: '📺 觀看廣告',
  boost_confirm: '▶ 看廣告套用',
  boost_close: '關閉',
  boost_applied: '機率提升已套用！',
  boost_already_applied: '已在套用中！',
  boost_exhausted: '使用次數已用盡！',
  boost_remaining: '🎬 剩餘使用次數：{current}/3',
  boost_popup_desc: '目前 {rate}% → 套用 {mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: '2倍',
  boost_mult_1_5x: '1.5倍',
  boost_mult_1_3x: '1.3倍',

  protection_popup_title: '🛡️ 使用防護券',
  protection_use: '使用',
  protection_cancel: '取消',
  protection_popup_info:
    '目前等級：Lv.{level}\n需要：{name} 1 張\n持有：{count} 張',
  protection_activated: '{name} 已啟用！',
  protection_returned: '{name} 已歸還',
  protection_protected: '🛡️ 被防護券保護！',

  msg_max_level: '已經是最高等級！',
  msg_gold_short: '金幣不足！',
  msg_success_boost: '強化成功（已加成）！',
  msg_success: '強化成功！',
  msg_destroyed: '💥 毀壞！',

  shop_title: '商店',
  tab_protection: '防護捲軸',
  tab_weapons: '購買武器',
  weapon_shop_title: '⚔️ 購買武器',
  item_free: '免費',
  close_shop: '關閉',
  buy_complete_title: '購買完成！',
  buy_complete_desc: '您購買的物品可於\n頂部 ⚙️ 設定 → 📦 背包中\n查看！',
  buy_complete_ok: '確認',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} 獲得！',
  weapon_moved_to_inventory: '{name} → 背包',
  price_display: '{amount}G',
  sell_received: '獲得 {amount}G！',

  destroy_title: '武器已被毀壞',
  destroy_ad_restore: '▶ 看廣告恢復',
  destroy_restore_ad: '看廣告恢復 ({current}/{max})',
  destroy_give_up: '重新開始',
  destroy_restore_count: '🎬 剩餘恢復次數：{current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: '廣告播放失敗',
  weapon_restored: '{name} 恢復完成！',

  completion_title: '你完成了最強之劍！',
  completion_all_done: '🏆 所有強化完成！ 🏆',
  congrats_text: '🎉 恭喜你！ 🎉',
  register_name: '✏️ 登記名字',
  prompt_register_name: '請輸入要登入名人堂的名字：',
  no_completion: '尚無完成者',
  be_first: '成為第一位完成者！',
  completion_close: '關閉',
  leaderboard_title: '📋 名人堂',
  leaderboard_entry: '第{rank}名 - {name}',
  completion_rank_msg: '你是第 {rank} 位完成者！',
  completion_total_msg: '目前已有 {total} 位玩家完成',

  weapon_image_load_failed: '武器圖片載入失敗：',

  weapon_0: '空手',
  weapon_1: '普通短劍',
  weapon_2: '鐵劍',
  weapon_3: '銀劍',
  weapon_4: '滑板劍',
  weapon_5: '波紋劍',
  weapon_6: '魔法少女劍',
  weapon_7: '熊熊劍',
  weapon_8: '燃燒骷髏劍',
  weapon_9: '閃電劍',
  weapon_10: '月光短劍',
  weapon_11: '龍之劍',
  weapon_12: '肌肉劍',
  weapon_13: '王鑽石劍',
  weapon_14: '青龍偃月刀',
  weapon_15: '古代劍',
  weapon_16: '海賊王雙劍',
  weapon_17: '杜拜Q彈劍',
  weapon_18: '七七刀',
  weapon_19: '魔法少女權杖劍',
  weapon_20: '嗡嗡劍',
  weapon_21: '調色盤劍',
  weapon_22: '大自然之劍',
  weapon_23: '機械人劍',
  weapon_24: '黑洞劍',
  weapon_25: '金鳥劍',
  weapon_26: '水晶能量劍',
  weapon_27: '暗黑龍劍',
  weapon_28: '鉗爪劍',
  weapon_29: 'AI劍',
  weapon_30: '電鋸劍',
  weapon_31: '流星力量劍',
  weapon_32: '極暗劍',
  weapon_33: '銀河劍',
  weapon_34: '超貴鑽石劍',

  scroll_basic: '初級防護券',
  scroll_mid: '中級防護券',
  scroll_hi: '高級防護券',
  scroll_ultra: '頂級防護券',
  scroll_label_basic: '初級',
  scroll_label_mid: '中級',
  scroll_label_hi: '高級',
  scroll_label_ultra: '頂級',

  // === Materials (Sprint 1) ===
  mat_iron_dust: '鐵粉',
  mat_refining_core: '精煉核心',
  mat_lava_essence: '熔岩精華',
  mat_abyss_crystal: '深淵結晶',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: '獲得素材！',
  mat_double_ad: '看廣告翻倍',
  mat_doubled: '翻倍生效！',
  mat_panel_title: '素材',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: '保管',
  keep_full: '保管庫已滿！',
  keep_lv1_blocked: 'Lv.1 武器無法保管',
  keep_success: '{name} 已保管！',
  keep_retrieve: '裝備',
  keep_sell: '出售',
  keep_slot_expand: '擴充欄位',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: '欄位: {used}/{total}',
  keep_panel_title: '保管武器',
  keep_empty: '無保管武器',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: '請擴充欄位！',

  // === 熔爐 (Sprint 2) ===
  tab_forge: '熔爐',
  forge_title: '熔爐',
  forge_tab_weapon: '武器',
  forge_tab_scroll: '卷軸',
  forge_tab_upgrade: '素材升階',
  forge_craft_btn: '製作',
  forge_craft_success: '{name} 製作完成！',
  forge_not_enough_mat: '素材不足',
  forge_weapon_to_equip: '立刻裝備嗎？',
  forge_weapon_to_keep: '保管',
  forge_weapon_equip: '裝備',
  forge_keep_full_equip: '保管庫已滿 — 直接裝備。',
  forge_cost_label: '費用:',
  forge_result_label: '結果:',

  forge_recipe_weapon_lv5: '製作 Lv.5 武器',
  forge_recipe_weapon_lv10: '製作 Lv.10 武器',
  forge_recipe_weapon_lv15: '製作 Lv.15 武器',
  forge_recipe_weapon_lv21: '製作 Lv.21 武器（保底）',
  forge_recipe_weapon_lv21_desc: '免強化直接獲得Lv.21武器！(不會失敗)',
  forge_recipe_scroll_basic: '製作初級保護卷軸',
  forge_recipe_scroll_mid: '製作中級保護卷軸',
  forge_recipe_scroll_hi: '製作高級保護卷軸',
  forge_recipe_scroll_ultra: '製作頂級保護卷軸',
  forge_recipe_upgrade_1: '鐵粉 → 精煉核心',
  forge_recipe_upgrade_2: '精煉核心 → 熔岩精華',
  forge_recipe_upgrade_3: '熔岩精華 → 深淵結晶',

  scroll_effect_basic: '防止 Lv.1-9 強化失敗時破損',
  scroll_effect_mid: '防止 Lv.10-19 強化失敗時破損',
  scroll_effect_hi: '防止 Lv.20-24 強化失敗時破損',
  scroll_effect_ultra: '防止 Lv.25-34 強化失敗時破損',
  scroll_buy_btn: '購買',

  keep_card_equip: '裝備',
  keep_card_sell: '出售',
  keep_slot_empty: '空槽',

  sacrifice_btn: '獻祭武器',
  sacrifice_panel_title: '獻祭武器',
  sacrifice_panel_desc: '獻祭Lv.{level}武器，每件提升成功率+{tierPct}%',
  sacrifice_empty: '保管庫無Lv.{level}武器',
  sacrifice_bonus_label: '加成: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: '獻祭',
  sacrifice_ad_slots: '看廣告 成功率 +{pct}%',
  sacrifice_ad_exhausted: '廣告次數已達上限',
  sacrifice_ad_granted: '追加+3祭品成功！',
  sacrifice_added: '獻祭成功！+{tierPct}%加成',
  sacrifice_cap_reached: '獻祭上限已達',
  sacrifice_reset: '獻祭加成重置',

  infinity_btn: '無限模式',
  infinity_active: '免費 {sec}秒',
  infinity_popup_title: '無限模式',
  infinity_popup_desc: '10秒內免黃金盡情強化！\n成功率與平時相同 — 失敗仍會破壞！',
  infinity_popup_confirm: '看廣告',
  infinity_popup_close: '關閉',
  infinity_cooldown: '{sec}秒後可用',
  infinity_daily_exhausted: '今日上限已達',
  infinity_started: '無限模式開啟！10秒免費',
  infinity_ended: '無限模式結束',

  buff_item_luck_charm: '幸運符',
  buff_item_guarantee: '保證強化券',
  buff_item_destroy_guard: '防毀護符',
  buff_item_use: '使用',
  buff_item_active: '生效中',
  buff_item_empty: '0',
  buff_luck_charm_activated: '幸運符生效！下次強化+5%',
  buff_guarantee_activated: '保證強化券生效！下次強化100%成功',
  buff_destroy_guard_activated: '防毀護符生效！下次失敗不毀壞',
  buff_luck_charm_consumed: '幸運符已消耗',
  buff_guarantee_consumed: '保證強化券已消耗',
  buff_destroy_guard_consumed: '防毀護符已消耗 — 防止毀壞！',
  buff_item_already_active: '已生效中！',
  buff_item_none: '沒有{name}',
  buff_popup_count: '持有: {count}個',
  buff_popup_use_btn: '立即使用',
  buff_popup_no_stock: '尚未持有。請在熔爐中製作。',
  buff_popup_luck_charm_effect: '下次強化成功率+5%',
  buff_popup_guarantee_effect: '下次強化1次保證100%成功',
  buff_popup_destroy_guard_effect: '下次強化失敗時，武器不會被毀壞（1次）',

  forge_recipe_item_luck_charm: '製作幸運符',
  forge_recipe_item_luck_charm_desc: '下次強化成功率+5%',
  forge_recipe_item_guarantee: '製作保證強化券',
  forge_recipe_item_guarantee_desc: '下次強化100%成功',
  forge_recipe_item_destroy_guard: '製作防毀護符',
  forge_recipe_item_destroy_guard_desc: '下次失敗時防止毀壞',
  forge_tab_item: '道具',
};

export default zhHant;
